<template>
    <div>
        <div class="page-title">超级管理员信息</div>
        
        <pay-box title="超级管理员信息"
                 sub-title="超级管理员将接收开户信息及完成签约，并可进行商户号的日常重要管理及资金操作。">
            
            <div v-if="ready">
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">超管身份</div>
                    
                    <div class="pay-apply-item-content">
                        
                        <a-radio-group v-model="params.contact_info.contact_type" @change="contactTypeChange">
                            <a-radio value="LEGAL">法定代表人/经营者</a-radio>
                            <a-radio value="SUPER">经办人</a-radio>
                        </a-radio-group>
                    
                    </div>
                
                </div>
                
                <template v-if="params.contact_info.contact_type == 'SUPER' ">
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">
                            <span>超管姓名</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            <at-input v-model="params.contact_info.contact_name" class="pay-apply-input"/>
                        </div>
                    
                    </div>
                    
                    <div class="pay-apply-item has-tips">
                        
                        <div class="pay-apply-item-title">
                            <span>身份证人像面照片</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            <div class="thumb-img">
                                
                                <upload-image
                                    v-model="params.contact_info.img_a_url"
                                    :action="uploadIdCardAUrl"
                                    :done="idCardADone"
                                    class="pay-apply-upload"
                                />
                            
                            </div>
                        </div>
                    </div>
                    
                    <div class="pay-apply-item has-tips">
                        
                        <div class="pay-apply-item-title">
                            <span>身份证国徽面照片</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            <div class="thumb-img">
                                
                                <upload-image
                                    v-model="params.contact_info.img_b_url"
                                    :action="uploadIdCardBUrl"
                                    :done="idCardBDone"
                                    class="pay-apply-upload"
                                />
                            
                            </div>
                        </div>
                    </div>
                    
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">
                            <span>身份证件号码</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            <at-input v-model="params.contact_info.contact_id_number"
                                      class="pay-apply-input"/>
                        </div>
                    
                    </div>
                    
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">
                            <span>身份证件号码</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            
                            <a-radio-group @change="idCardTypeChanged" v-model="hp.idCardType">
                                <a-radio :value="1">定期</a-radio>
                                <a-radio :value="2">长期</a-radio>
                            </a-radio-group>
                        
                        </div>
                    
                    </div>
                    
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">
                            <span>证件生效日期</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            
                            <a-date-picker
                                v-model="params.contact_info.contact_period_begin"
                                class="date-picker pay-apply-input"
                                format="YYYY-MM-DD"
                                placeholder="选择日期"
                            />
                        
                        </div>
                    
                    </div>
                    
                    <div class="pay-apply-item" v-if=" hp.idCardType === 1 ">
                        
                        <div class="pay-apply-item-title">
                            <span>证件失效日期</span>
                            <br>
                            <span>(经办人)</span>
                        </div>
                        
                        <div class="pay-apply-item-content">
                            
                            <a-date-picker
                                v-model="params.contact_info.contact_period_end"
                                class="date-picker pay-apply-input"
                                format="YYYY-MM-DD"
                                placeholder="选择日期"
                            />
                        
                        </div>
                    
                    </div>
                
                </template>
                <template v-else>
                    <div class="pay-apply-item">
                        
                        <div class="pay-apply-item-title">超管姓名</div>
                        
                        <div class="pay-apply-item-content">
                            {{ params.contact_info.contact_name }}
                        </div>
                    
                    </div>
                </template>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">手机号码</div>
                    
                    <div class="pay-apply-item-content">
                        <at-input v-model="params.contact_info.mobile_phone" unit="+86" class="pay-apply-input"/>
                    </div>
                
                </div>
                
                <div class="pay-apply-item">
                    
                    <div class="pay-apply-item-title">邮箱</div>
                    
                    <div class="pay-apply-item-content">
                        <at-input v-model="params.contact_info.contact_email" class="pay-apply-input"/>
                    </div>
                
                </div>
                
                <div class="pay-apply-tips">用于接收微信支付的开户邮件及日常业务通知</div>
            </div>
            <div v-else>
                <p>请先完成主体资料填写</p>
                <a @click="changeStep(3)">立即前往</a>
            </div>
        
        </pay-box>
        
        <div class="pay-apply-btns">
            <button @click="saveChange(2)" class="btn btn-white">返回</button>
            <button @click="saveChange(2)" class="btn">下一步</button>
        </div>
    
    </div>
</template>

<script>
import PayBox from "./PayBox";
import AtInput from "../../../../components/AtInput";
import api from "../../../../repo/api";
import UploadImage from "@/components/UploadImage.vue";

export default {
    name: "Step6",
    components: {UploadImage, AtInput, PayBox},
    props: {
        apply: Object
    },
    data() {
        return {
            ready: false,
            hp: {
                idCardType: 1
            },
            params: {
                contact_info: {
                    contact_name: '',
                    mobile_phone: '',
                    contact_email: '',
                    contact_type: 'LEGAL',
                    img_a_url: "",
                    img_b_url: "",
                }
            }
        }
    },
    computed: {
        uploadBusLicUrl() {
            return api.colUrl('/pay-apply/upload-business-license')
        },
        uploadIdCardAUrl() {
            return api.colUrl('/pay-apply/upload-id-card-a')
        },
        uploadIdCardBUrl() {
            return api.colUrl('/pay-apply/upload-id-card-b')
        },
    },
    mounted() {
        
        let info = this.apply['subject_info']['identity_info']
        if (!info) return
        
        info = info['id_card_info']
        if (!info) return
        
        // --- 修改开始 ---
        
        // 获取传入的 contact_info，如果没有则为空对象
        const incomingContactInfo = this.apply['contact_info'] || {};
        
        // 使用 Object.assign 将传入的数据合并到原本的响应式对象中
        // 这样 data() 里定义的 contact_type 的响应式特性得以保留
        this.params.contact_info = Object.assign({}, this.params.contact_info, incomingContactInfo);
        
        // 设置名字
        this.params.contact_info.contact_name = info['id_card_name']
        
        // 如果合并后依然没有 type，则设为默认值
        if (!this.params.contact_info.contact_type) {
            this.params.contact_info.contact_type = 'LEGAL'
        }
        
        this.ready = true
    },
    methods: {
        contactTypeChange() {
            if (this.params.contact_info.contact_type == 'LEGAL') {
                
                let info = this.apply['subject_info']['identity_info']
                
                if (!info) return
                
                info = info['id_card_info']
                
                if (!info) return
                // 设置名字
                this.params.contact_info.contact_name = info['id_card_name']
            } else {
                this.params.contact_info.contact_name = ''
            }
        },
        changeStep(step) {
            this.$emit('change', step)
        },
        saveChange(step) {
            
            if (!this.ready) return this.changeStep(step)
            
            this.$loading.show()
            
            api.post('/pay-apply/save-contact-info', this.params, (data) => {
                
                this.$loading.hide()
                
                if (data.code !== 0) this.$message.data(data)
                
                if (data.code === 0) {
                    this.$emit('change', step, data.data)
                }
                
            })
        },
        idCardADone(res) {
            
            this.params.contact_info.contact_id_doc_copy = res['media_id']
            this.params.contact_info.img_a_url = res['img_url']
            
            this.params.contact_info.contact_name = res['name']
            this.params.contact_info.contact_id_doc_type = 'IDENTIFICATION_TYPE_IDCARD'
            this.params.contact_info.contact_id_number = res['id']
        },
        idCardBDone(res) {
            
            this.params.contact_info.contact_id_doc_copy_back = res['media_id']
            this.params.contact_info.img_b_url = res['img_url']
            
            this.params.contact_info.contact_period_begin = res['date_begin']
            this.params.contact_info.contact_period_end = res['date_end']
            
            
            this.hp.idCardType = res['date_end'] === '长期' ? 2 : 1
        },
        idCardTypeChanged(val) {
            
            this.params.contact_info.contact_period_end
                = val === 1 ? '' : '长期'
            
        },
    }
}
</script>

<style scoped>
.pay-apply-item-title {
    width: 115px;
    text-align: right;
}
</style>